import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const usePay = (orderId: string, payMethod: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("usePaymethodcontext---------", context.useApiError);
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const result = sharedRef(null, `usePay-${orderId}-${payMethod}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `usePay-loading-${orderId}-${payMethod}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `usePay-error-${orderId}-${payMethod}`);

  // 发起支付
  const pay = async (customQuery) => {
    try {
      loading.value = true;
      // console.log("pay参数---------", customQuery);
      const res = await context.$xbuy.api.orderPay(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value = null;
      } else if (res && res.code === 3107) {
        if (res.message.indexOf('{time}') > -1) {
          res.message = res.message.replace('{time}', res.data?.lock_ttl);
        }
        setError({ code: res.code, message: res.message });
        error.value = res.message;
      } else {
        error.value = res.message;
        setError({ code: res.code, message: res.message });
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    pay,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
